export * from '@primeuix/themes/material/slider';
export { default } from '@primeuix/themes/material/slider';
